export { default } from './InfoBox';